import { useNavigate } from 'react-router-dom';
import { RoutingValues } from '../../../types/Shared.types';
import { ColDef } from 'ag-grid-community';
import DefaultColumnTypes from '../../../components/grids/columns/Column.constants';
import { PermissionsUtil } from '../../../utils/permissions/permissionsUtil';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { PERMISSIONS } from '../../../constants/permissions/Permissions.constants';
import { useGetAttributeTemplatesQuery } from '../../../services/attributes/attributes.service';
import { skipToken } from '@reduxjs/toolkit/query';
import LockedCellRenderer from '../../../components/grids/cellRenderers/lockedCell.renderer';

const useAttributeTemplatesGrid = (attrEntityId: any) => {
    const user = useSelector((state: RootState) => state.user);
    const navigate = useNavigate();

    const { data: attributeTemplates, isLoading: isLoadingTemplates } =
        useGetAttributeTemplatesQuery(attrEntityId ? attrEntityId : skipToken);

    const canManageAttribute = PermissionsUtil.isPermissionEnabled(
        user?.permissions,
        PERMISSIONS.SETUP.ATTRIBUTES.MANAGE
    );

    const redirectToForm = (row: any) => {
        if (row.id) {
            navigate(`/setup/attributes/templates/${row.id}`, {
                state: { attrEntityId: attrEntityId },
            });
        } else {
            navigate(`/setup/attributes/templates/${RoutingValues.newId}`, {
                state: { attrEntityId: attrEntityId },
            });
        }
    };
    //TODO: determine if these are all of the columns to use or if they need to change
    const attributeTemplatesColDef: ColDef[] = [
        {
            field: 'code',
            headerName: 'Template Code',
            filter: 'agTextColumnFilter',
            floatingFilter: true,
        },
        {
            field: 'name',
            headerName: 'Template Name',
            filter: 'agTextColumnFilter',
            floatingFilter: true,
        },
        {
            field: 'attrEntity.name',
            headerName: 'Data Entity',
            filter: 'agTextColumnFilter',
            floatingFilter: true,
        },
        {
            field: 'locked',
            headerName: 'Locked',
            ...DefaultColumnTypes.Locked,
        },
    ];

    const frameworkComponents = {
        lockedCellRenderer: LockedCellRenderer,
    };
    return {
        redirectToForm,
        attributeTemplatesColDef,
        canManageAttribute,
        attributeTemplates,
        isLoadingTemplates,
        frameworkComponents,
    };
};

export default useAttributeTemplatesGrid;
